import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Wordmark } from "@/components/common/Wordmark";
import { Spinner } from "@/components/common/States";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/lib/api";

export default function LoginPage() {
  const { me, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (me) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return setErr("Email dan kata sandi wajib diisi.");
    setBusy(true);
    setErr("");
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (ex) {
      setErr(errorMessage(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <section className="hidden lg:flex flex-col justify-between bg-[#0B3D91] text-white p-14 relative overflow-hidden">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full border-[48px] border-white/5" aria-hidden />
        <div className="absolute right-20 bottom-40 h-3 w-40 bg-[#E11D2E]" aria-hidden />
        <Wordmark size="lg" inverted />
        <div className="max-w-md sist-rise">
          <p className="font-brand text-3xl font-extrabold leading-tight">Satu sistem, banyak sekolah, data tetap terpisah.</p>
          <p className="mt-4 text-white/75 text-sm">Pusat Kendali SIST untuk Admin Platform dan Dasbor Admin Sekolah untuk setiap sekolah, dengan hak akses yang diperiksa di server.</p>
        </div>
        <p className="text-xs text-white/50">Tahap 1 · Fondasi keamanan multi-sekolah</p>
      </section>
      <section className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 sist-rise" data-testid="login-form" noValidate>
          <div className="lg:hidden"><Wordmark /></div>
          <div>
            <h1 className="font-brand text-3xl font-extrabold">Masuk</h1>
            <p className="text-sm text-muted-foreground mt-1">Gunakan akun yang diberikan melalui undangan resmi.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nama@sekolah.sch.id" data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Kata sandi</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Masukkan kata sandi" data-testid="login-password-input" />
          </div>
          {err && <p className="text-sm text-[#E11D2E]" role="alert" data-testid="login-error">{err}</p>}
          <Button type="submit" className="w-full h-11" disabled={busy} data-testid="login-submit-button">{busy && <Spinner />} Masuk</Button>
          <p className="text-xs text-muted-foreground">Tidak ada pendaftaran mandiri. Akun dibuat melalui tautan undangan dari Admin Platform atau Admin Sekolah.</p>
        </form>
      </section>
    </div>
  );
}
